/**
 * Constantes y escenarios mock de Phase 2 (prenda / pre-oferta).
 * TODO: Reemplazar mocks por contratos Swagger cuando carlos termine.
 */

export const DIGITAL_LOAN_PHASE2_STEPS = Object.freeze({
  GUARANTEE_AVAILABILITY: 'guarantee-availability',
  GUARANTEE_FAMILY: 'guarantee-family',
  GUARANTEE_SUBFAMILY: 'guarantee-subfamily',
  GUARANTEE_ARTICLE: 'guarantee-article',
  GUARANTEE_BRAND: 'guarantee-brand',
  GUARANTEE_MODEL: 'guarantee-model',
  PHOTO_REQUIREMENTS: 'photo-requirements',
  PHOTO_CAPTURE: 'photo-capture',
  PHOTO_REVIEW: 'photo-review',
  VALIDATION_FAILED: 'validation-failed',
  INSUFFICIENT_VALUE: 'insufficient-value',
  MISSING_ONBOARDING: 'missing-onboarding',
  NOT_PREAPPROVED: 'not-preapproved',
  PRE_OFFER: 'pre-offer',
});

export const DIGITAL_LOAN_PHASE2_STEP_ORDER = Object.freeze([
  DIGITAL_LOAN_PHASE2_STEPS.GUARANTEE_AVAILABILITY,
  DIGITAL_LOAN_PHASE2_STEPS.GUARANTEE_FAMILY,
  DIGITAL_LOAN_PHASE2_STEPS.GUARANTEE_SUBFAMILY,
  DIGITAL_LOAN_PHASE2_STEPS.GUARANTEE_ARTICLE,
  DIGITAL_LOAN_PHASE2_STEPS.GUARANTEE_BRAND,
  DIGITAL_LOAN_PHASE2_STEPS.GUARANTEE_MODEL,
  DIGITAL_LOAN_PHASE2_STEPS.PHOTO_REQUIREMENTS,
  DIGITAL_LOAN_PHASE2_STEPS.PHOTO_CAPTURE,
  DIGITAL_LOAN_PHASE2_STEPS.PHOTO_REVIEW,
  DIGITAL_LOAN_PHASE2_STEPS.VALIDATION_FAILED,
  DIGITAL_LOAN_PHASE2_STEPS.INSUFFICIENT_VALUE,
  DIGITAL_LOAN_PHASE2_STEPS.MISSING_ONBOARDING,
  DIGITAL_LOAN_PHASE2_STEPS.NOT_PREAPPROVED,
  DIGITAL_LOAN_PHASE2_STEPS.PRE_OFFER,
]);

/** Query param QA: digitalLoanPhase2Mock=success|validation-failed|... */
export const PHASE2_MOCK_QUERY_KEY = 'digitalLoanPhase2Mock';

/**
 * TEMP DEMO BYPASS REMOVER CUANDO CARLOS TERMINE EL BACK
 * Query: digitalLoanGuaranteeMock=success
 */
export const GUARANTEE_MOCK_QUERY_KEY = 'digitalLoanGuaranteeMock';
export const GUARANTEE_MOCK_SUCCESS_VALUE = 'success';
/** sessionStorage key — TEMP DEMO BYPASS removable. */
export const GUARANTEE_MOCK_STORAGE_KEY = 'digitalLoanGuaranteeMockSuccess';

export const PHASE2_MOCK_SCENARIOS = Object.freeze({
  SUCCESS: 'success',
  VALIDATION_FAILED: 'validation-failed',
  INSUFFICIENT_VALUE: 'insufficient-value',
  MISSING_ONBOARDING: 'missing-onboarding',
  NOT_PREAPPROVED: 'not-preapproved',
  PREOFFER: 'preoffer',
});

export const PHASE2_MOCK_SCENARIO_DEFAULT = PHASE2_MOCK_SCENARIOS.PREOFFER;

/** Tasa mock hasta que Backend defina el contrato de recálculo. */
export const MOCK_LOAN_RATE = 48;

export const PRODUCT_CONDITIONS = Object.freeze({
  EXCELLENT: 'excellent',
  GOOD: 'good',
  FAIR: 'fair',
});

/**
 * Ajuste de customerDeclaredValue solo para path manual.
 * Por petición de MLS No aplica a ítems de catálogo. No calcula el monto del préstamo.
 */
export const MANUAL_CONDITION_ADJUSTMENT = Object.freeze({
  [PRODUCT_CONDITIONS.EXCELLENT]: 1.05,
  [PRODUCT_CONDITIONS.GOOD]: 1,
  [PRODUCT_CONDITIONS.FAIR]: 0.9,
});

export const REQUIRED_ANGLE_PHOTOS = 5;

export const REQUIRED_PHOTO_ANGLES = Object.freeze([
  'TRASERA',
  'LATERAL_DERECHA',
  'LATERAL_IZQUIERDA',
  'SUPERIOR',
  'INFERIOR',
]);

export const OTHER_OPTION_ID = 'other';

/** Label UI de OTRO. Nunca enviar OTHER_OPTION_ID en /guarantee. */
export const MANUAL_OTHER_NAME = 'OTRO';

/**
 * Id interno del modelo capturado a mano (UI).
 * No se envía como sap*Code de campos manuales; el contrato usa
 * manualXName. sapModelCode "0" solo aplica a ID_MODELO de catálogo.
 */
export const MANUAL_CATALOG_CODE = '0';

/** Longitud máxima de nombres manuales en /guarantee. */
export const MANUAL_NAME_MAX_LENGTH = 255;

export const OTHER_OPTION = Object.freeze({
  id: OTHER_OPTION_ID,
  name: MANUAL_OTHER_NAME,
});

export const MANUAL_MODEL_CODE = MANUAL_CATALOG_CODE;

export const MANUAL_CATALOG_LEVELS = Object.freeze({
  FAMILY: 'family',
  SUBFAMILY: 'subfamily',
  ARTICLE: 'article',
  BRAND: 'brand',
  MODEL: 'model',
});
